import UploadControl from "./upload-control";

export default class FieldsetRepeatable {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.amount = this.$wrapper.querySelector('[data-form-fieldsets-amount]');
        this.fieldsetWrapper = this.$wrapper.querySelector('[data-form-fieldset-wrapper]');
        this.originalFieldset = this.$wrapper.querySelector('[data-form-fieldset]');
        this.add = this.$wrapper.querySelector('[data-add-fieldset]');
        this.remove = this.$wrapper.querySelectorAll('[data-remove-fieldset]');
        this.titles = this.$wrapper.querySelectorAll('.form__legend-subtitle');

        this.addFieldset = this.addFieldset.bind(this);
        this.removeFieldset = this.removeFieldset.bind(this);
        this.updateTitles = this.updateTitles.bind(this);

        this.add.addEventListener('click', this.addFieldset);

        // hide remove buttons default
        if (this.$wrapper.querySelectorAll('[data-form-fieldset]').length === 1) {
            this.remove.forEach(button => button.style.display = 'none');
        } else {
            // [20250502] - When a form error happened, these remove buttons didn't have a click event
            // Now adding them here on page load
            this.$wrapper.querySelectorAll('[data-form-fieldset]').forEach((el) => {
                el.addEventListener('click', this.removeFieldset);
            });
        }

        // Add number to titles
        this.updateTitles();
    }

    addFieldset(e) {
        e.preventDefault();

        this.amount.value = parseInt(this.amount.value) + 1;
        const clonedFieldset = this.originalFieldset.cloneNode(true);

        // Clear input values in cloned fieldset
        clonedFieldset.querySelectorAll('input, select').forEach(input => {
            this.updateAttributes(input);
        });

        this.fieldsetWrapper.appendChild(clonedFieldset);

        if (this.$wrapper.querySelectorAll('[data-form-fieldset]').length > 1) {
            this.remove = this.$wrapper.querySelectorAll('[data-remove-fieldset]');
            this.remove.forEach(remove => remove.style.display = 'initial');

            this.remove = this.$wrapper.querySelectorAll('[data-remove-fieldset]');
            this.remove.forEach(button => button.addEventListener('click', this.removeFieldset));
        }

        clonedFieldset.querySelectorAll('[type="radio"]').forEach(($el) => {
            $el.checked = false;
        });
        clonedFieldset.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));

        this.removeUploadedFiles(clonedFieldset);
        this.updateTitles();
        clonedFieldset.scrollIntoView({behavior: 'smooth'});
    }

    removeUploadedFiles(clonedFieldset) {
        const controls = clonedFieldset.querySelectorAll('[data-upload]')

        controls.forEach(field => {
            const control = field.querySelector('[data-upload-control]');
            const names = field.querySelector('[data-file-upload-names]');
            const noFiles = field.querySelector('[data-file-upload-no-files]');
            const target = field.querySelector('[data-delete-file]');

            const fileId = target.dataset.deleteFile;
            const dt = new DataTransfer()
            const {files} = control;

            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                if ((file.name + file.lastModified) !== fileId) {
                    dt.items.add(file) // here you exclude the file. thus removing it.
                }
            }

            control.files = dt.files // Assign the updates list
            // make the file list empty
            names.querySelector('[data-file="' + fileId + '"]').remove();

            if (!dt.files.length) {
                noFiles.classList.remove('d-none');
            }
        })
    }

    updateAttributes(input) {
        const label = input.closest('.form__group').querySelector('label');

        input.value = '';
        input.closest('.form__group').classList.remove('form__group--success');
        input.closest('.form__group').classList.remove('form__group--error');

        input.setAttribute(
            'name',
            input.getAttribute('name')
                .replace('[0]', '[' + (this.$wrapper.querySelectorAll('[data-form-fieldset]').length) + ']')
        );

        if (input.getAttribute('id')) {
            input.setAttribute(
                'id',
                input.getAttribute('id')
                    .replace('[0]', '[' + (this.$wrapper.querySelectorAll('[data-form-fieldset]').length) + ']')
            );
        }

        if (input.getAttribute('data-block-control-id')) {
            input.setAttribute(
                'data-block-control-id',
                input.getAttribute('data-block-control-id')
                    .replace('[0]', '[' + (this.$wrapper.querySelectorAll('[data-form-fieldset]').length) + ']')
            );
        }

        if (label.getAttribute('for')) {
            label.setAttribute(
                'for',
                label.getAttribute('for')
                    .replace('[0]', '[' + (this.$wrapper.querySelectorAll('[data-form-fieldset]').length) + ']')
            )
        }
    }

    removeFieldset(e) {
        e.preventDefault();

        this.amount.value = parseInt(this.amount.value) - 1;
        e.target.closest('[data-form-fieldset]').remove();

        this.remove = this.$wrapper.querySelectorAll('[data-remove-fieldset]');
        if (this.$wrapper.querySelectorAll('[data-form-fieldset]').length === 1) {
            this.remove.forEach(button => button.style.display = 'none');
        }

        this.updateTitles();
    }

    updateTitles() {
        this.titles = this.$wrapper.querySelectorAll('.form__legend-subtitle');
        this.titles.forEach((title, index) => title.innerHTML = '<span>' + title.querySelector('span').innerHTML + '</span> ' + (index + 1));
    }
}
